import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthApiService } from '../../services/api/auth-api.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;

    constructor(
        private fb: FormBuilder,
        private authService: AuthApiService,
        private router: Router,
        private snackBar: MatSnackBar
    ) {}

    ngOnInit(): void {
        this.loginForm = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    onSubmit(): void {
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        const { username, password } = this.loginForm.value;

        this.authService.login('WEB', username, password).subscribe({
            next: (success) => {
                if (success) {
                    this.router.navigate(['/certificados']);
                }
            },
            error: (error) => {
                this.loading = false;
                this.snackBar.open(error.message, 'Cerrar', {
                    duration: 5000,
                    panelClass: ['error-snackbar']
                });
            },
            complete: () => {
                this.loading = false;
            }
        });
    }
}